import { getTodayIST } from '@/lib/dateFormat';

const IST_DAY = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' });

type LockableActivity = { status: string; date_time: string };

function isPastUncompleted(activity: LockableActivity): boolean {
  if (activity.status === 'completed') return false;
  return IST_DAY.format(new Date(activity.date_time)) < getTodayIST();
}

/**
 * A DM activity is read-only (no status change, edit, complete or assign) when:
 *  - it is Cancelled — cancelling is permanent and moves it to Storage, or
 *  - it is dated before today (IST) and was never completed.
 * Completed past activities stay open for post-shoot work; delete is always allowed.
 * The backend enforces the same rule (assertActivityNotLocked in dm-team.service.ts).
 */
export function isActivityLocked(activity: LockableActivity): boolean {
  return activity.status === 'cancelled' || isPastUncompleted(activity);
}

export function activityLockHint(activity: LockableActivity): string {
  return activity.status === 'cancelled' ? 'Cancelled — permanent' : 'Past activity — read only';
}

export const CANCEL_CONFIRM_TITLE = 'Cancel this activity permanently?';
export const CANCEL_CONFIRM_TEXT =
  "It moves to Storage and can't be changed again — no status change, edit or re-assign.";
